import React from "react";
import { useStaffTenders } from "../../hooks/stafftender/useStaffTenders";
import StaffTendersHeader from "../../components/stafftender/StaffTendersHeader";
import StaffTendersMainContent from "../../components/stafftender/StaffTendersMainContent";
import TenderFilterModal from "../../components/club/TenderFilterModal";

const StaffTenders = () => {
  const {
    navigate,
    canCreateTenders,
    canViewPitches,
    staffInClub,
    activeMainTab,
    setActiveMainTab,
    activeSubTab,
    setActiveSubTab,
    selectedCountry,
    tenders,
    loading,
    error,
    showFilterModal,
    setShowFilterModal,
    countries,
    isTransferWindowDropdownOpen,
    transferWindow,
    transferWindowLoading,
    searchQuery,
    setSearchQuery,
    dropdownRef,
    searchInputRef,
    isMobile,
    isYouthStaff,
    profileLoading,
    filters,
    searchTerm,
    sortBy,
    activePositionFilter,
    pagination,
    formatDateRange,
    handleTransferWindowDropdownToggle,
    handleCountrySelect,
    handleFilterChange,
    clearAllFilters,
    hasActiveFilters,
    getActiveFiltersCount,
    handleSortChange,
    handlePositionFilterChange,
    handleSearchChange,
    fetchTenders,
    handleSaveStatusChange,
    // Applied tab (self-applications)
    pitches,
    pitchStatus,
    handlePitchStatusChange,
    pitchPagination,
    handlePitchPageChange,
  } = useStaffTenders();

  if (profileLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex justify-center items-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <StaffTendersHeader
        isMobile={isMobile}
        transferWindowLoading={transferWindowLoading}
        transferWindow={transferWindow}
        formatDateRange={formatDateRange}
        dropdownRef={dropdownRef}
        searchInputRef={searchInputRef}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        handleTransferWindowDropdownToggle={handleTransferWindowDropdownToggle}
        countries={countries}
        selectedCountry={selectedCountry}
        isTransferWindowDropdownOpen={isTransferWindowDropdownOpen}
        handleCountrySelect={handleCountrySelect}
        staffInClub={staffInClub}
        canCreateTenders={canCreateTenders}
        activeMainTab={activeMainTab}
        setActiveMainTab={setActiveMainTab}
        searchTerm={searchTerm}
        handleSearchChange={handleSearchChange}
        setShowFilterModal={setShowFilterModal}
        hasActiveFilters={hasActiveFilters}
        getActiveFiltersCount={getActiveFiltersCount}
        clearAllFilters={clearAllFilters}
        sortBy={sortBy}
        handleSortChange={handleSortChange}
        isYouthStaff={isYouthStaff}
        canViewPitches={canViewPitches}
        navigate={navigate}
      />

      {/* Main Content */}
      <StaffTendersMainContent
        isMobile={isMobile}
        activeMainTab={activeMainTab}
        setActiveMainTab={setActiveMainTab}
        setShowFilterModal={setShowFilterModal}
        sortBy={sortBy}
        handleSortChange={handleSortChange}
        searchTerm={searchTerm}
        handleSearchChange={handleSearchChange}
        activeSubTab={activeSubTab}
        setActiveSubTab={setActiveSubTab}
        activePositionFilter={activePositionFilter}
        handlePositionFilterChange={handlePositionFilterChange}
        staffInClub={staffInClub}
        canViewPitches={canViewPitches}
        isYouthStaff={isYouthStaff}
        loading={loading}
        error={error}
        tenders={tenders}
        pagination={pagination}
        fetchTenders={fetchTenders}
        handleSaveStatusChange={handleSaveStatusChange}
        pitches={pitches}
        pitchStatus={pitchStatus}
        handlePitchStatusChange={handlePitchStatusChange}
        pitchPagination={pitchPagination}
        handlePitchPageChange={handlePitchPageChange}
      />

      {/* Filter Modal */}
      <TenderFilterModal
        isOpen={showFilterModal}
        onClose={() => setShowFilterModal(false)}
        onApply={handleFilterChange}
        initialFilters={filters}
        selectedType={activePositionFilter}
        /* DECISION 050 follow-up: the option counts describe the tab that is
           actually open — My Requests counts this club's own rows in every
           status, Saved counts the bookmarks, All Requests the active
           marketplace. Same for the TP-Lite sub-tab. */
        activeTab={activeMainTab}
        isLite={activeSubTab === "tp-lite-tenders"}
      />
    </div>
  );
};

export default StaffTenders;
